import { BreakdownTypes } from '@wix/cashier-express-checkout-widget/dist/src/types/PaymentBreakdown';
import { round } from './math.utils';
export function getPaymentBreakdown(_ref, taxOnProduct) {
  var _shippingInfo$selecte, _shippingInfo$selecte2, _payNow$shipping$amou, _payNow$shipping, _payNow$tax$amount, _payNow$tax, _payNow$discount$amou, _payNow$discount, _giftCard$amount$amou, _giftCard$amount;
  let {
    payNow,
    giftCard,
    lineItems,
    additionalFees,
    shippingInfo
  } = _ref;
  const itemsTotal = getItemsTotal(lineItems);
  const shippingTotal = taxOnProduct ? (_shippingInfo$selecte = shippingInfo == null || (_shippingInfo$selecte2 = shippingInfo.selectedCarrierServiceOption) == null || (_shippingInfo$selecte2 = _shippingInfo$selecte2.cost) == null || (_shippingInfo$selecte2 = _shippingInfo$selecte2.price) == null ? void 0 : _shippingInfo$selecte2.amount) != null ? _shippingInfo$selecte : '0' : (_payNow$shipping$amou = payNow == null || (_payNow$shipping = payNow.shipping) == null ? void 0 : _payNow$shipping.amount) != null ? _payNow$shipping$amou : '0';
  const taxTotal = taxOnProduct ? '0' : (_payNow$tax$amount = payNow == null || (_payNow$tax = payNow.tax) == null ? void 0 : _payNow$tax.amount) != null ? _payNow$tax$amount : '0';
  const discountTotal = (_payNow$discount$amou = payNow == null || (_payNow$discount = payNow.discount) == null ? void 0 : _payNow$discount.amount) != null ? _payNow$discount$amou : '0';
  const giftCardTotal = (_giftCard$amount$amou = giftCard == null || (_giftCard$amount = giftCard.amount) == null ? void 0 : _giftCard$amount.amount) != null ? _giftCard$amount$amou : '0';
  const additionalFeesTotal = getItemsTotal(additionalFees);
  const itemsTotalWithAdditionalFees = round(Number(itemsTotal) + Number(additionalFeesTotal)).toString();
  const totalDiscountWithGiftCard = round(Number(discountTotal) + Number(giftCardTotal)).toString();
  return {
    [BreakdownTypes.ItemsTotal]: itemsTotalWithAdditionalFees,
    [BreakdownTypes.Shipping]: shippingTotal,
    [BreakdownTypes.Tax]: taxTotal,
    [BreakdownTypes.Discount]: totalDiscountWithGiftCard
  };
}
function getItemsTotal(items) {
  const total = (items != null ? items : []).reduce((acc, _ref2) => {
    var _price$amount;
    let {
      price,
      quantity
    } = _ref2;
    return acc + Number((_price$amount = price == null ? void 0 : price.amount) != null ? _price$amount : '0') * (quantity != null ? quantity : 1);
  }, 0);
  return round(total).toString();
}
//# sourceMappingURL=getPaymentBreakdown.js.map